export const managerPerformanceInsightsHighchartsOptions = (seriesData: [string, number][]) => {
  return {
    chart: {
      type: 'column',
    },
    title: null,
    credits: {
      enabled: false,
    },
    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [-45, -90],
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif',
        },
      },
    },
    yAxis: {
      min: 0,
      title: null,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: 'Amount: <b>{point.y}</b>',
    },
    series: [
      {
        colors: [
          '#0F9D58',
          '#11BD6A',
          '#24DB82',
          '#45EA9A',
          '#68EFAD',
          '#95F9B3',
          '#B7FEBF',
          '#C2EDA8',
          '#DFFFBE',
          '#E7F2B6',
          '#F1EFA1',
          '#F5EEB4',
          '#F3E3AB',
          '#FFE48B',
          '#FFDB65',
          '#FFD651',
          '#FFC261',
          '#FEAD2D',
          '#FA8E22',
          '#FD700C',
          '#EA5A2E',
          '#FD4636',
          '#FF2A16',
          '#BF1010',
          '#9D0F0F',
        ],
        colorByPoint: true,
        groupPadding: 0,
        data: seriesData,
        dataLabels: {
          enabled: true,
          rotation: -90,
          color: '#FFFFFF',
          inside: true,
          verticalAlign: 'top',
          format: '{point.y:,.1f}',
          y: 10,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
    ],
  };
};
